import React from 'react';
import { MenuPrintConfig } from './types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const NewYorkHeader: React.FC<{ config: MenuPrintConfig }> = ({ config }) => {
  const { i18n } = useTranslation();
  if (!config.title) return null;
  moment.locale(i18n.language);

  return (
    <div style={{ paddingTop: 8, paddingBottom: 0 }}>
      {config.showDate && (
        <div
          style={{
            textAlign: 'right',
            padding: '0 10px 2px 10px',
            fontSize: 11,
            lineHeight: '13px',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}>
          {moment().format('ddd, MMM Do YYYY')}
        </div>
      )}
      <div
        style={{
          fontWeight: 700,
          fontSize: 44,
          textTransform: 'uppercase',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          lineHeight: '48px',
          letterSpacing: 0.3,
          padding: '0 10px'
        }}>
        {config.title}
      </div>
      <div style={{ borderTop: '1px solid #000', marginTop: 4, width: '100%' }} />
    </div>
  );
};

export default NewYorkHeader;
